















































import Component, { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
import { meterApi } from '../api/MeterApi';
import { MeterShowModel } from '@/context/meter/model/MeterShowModel';
import LocationShowContainer from '@/context/location/container/LocationShowContainer.vue';
import ModelShowContainer from '@/context/meter/model/container/ModelShowContainer.vue';
import { notNullOrUndefined } from '@/utility/functions';
import { dataLoggerRouter } from '@/context/data_logger/router/DataLoggerRouter';
// import DataLoggerShowContainer from "@/context/data_logger/containers/DataLoggerShowContainer.vue";
import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';

@Component({
  components: {
    ProgressSpinnerWrapper,
    // DataLoggerShowContainer,
    ModelShowContainer,
    LocationShowContainer,
    DetailRow
  }
})
export default class MeterShowContainer extends mixins(ShowContainer) {
  model!: MeterShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await meterApi.show(id);
    this.model = response?.data?.view;
  }

  get locationFetchable(): boolean {
    const result: boolean = notNullOrUndefined(this.model.location);
    return result;
  }

  get modelFetchable(): boolean {
    const result: boolean = notNullOrUndefined(this.model.model);
    return result;
  }

  // get dataLoggerFetchable(): boolean {
  //   const result: boolean = notNullOrUndefined(this.model.dataLogger);
  //   return result;
  // }

  get dataLoggerRoute(): Record<string, unknown> | null {
    return this?.model?.dataLogger ? dataLoggerRouter.show(this.model.dataLogger) : null;
  }

  get dataLoggerLabel(): string {
    return this.model.dataLogger ? "Przejdź do detali" : "";
  }
}
